<template>
  <v-menu
    v-model="isActive"
    offset-y
    transition="slide-y-transition"
    rounded="1"
    max-width="176"
    :nudge-top="-10"
    :nudge-left="-166"
    right
    content-class="filter__list mod--year LKRoadmapsFeedFilterYear"
  >
    <template #activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on">
        <FilterToggle
          title="Год ДК:"
          :desc="desc"
          :active="isActive"
        />
      </div>
    </template>

    <div
      v-for="year in years"
      :key="year"
      class="filter__option w-inline-block text-md-bold"
      :class="{ 'mod--active': year === value }"
      @click="select(year)"
      v-text="year"
    />
  </v-menu>
</template>

<script>
import FilterToggle from './LKRoadmapsFeedFilterToggle.vue'


export default {
  name: 'LKRoadmapsFeedFilterYear',
  components: {
    FilterToggle,
  },
  props: {
    years: Array,
  },
  data: (vm) => ({
    isActive: false,
    value: vm.years?.[0],
  }),
  computed: {
    desc() {
      return (this.value || '').toString()
    },
  },
  methods: {
    select(value) {
      this.value = value
      this.$emit('submit', value)
    },
  },
}
</script>

<style lang="scss">
.LKRoadmapsFeedFilterYear {
  .filter__option {
    cursor: pointer;

    &.mod--active {
      pointer-events: none;
      cursor: default;
    }
  }
}
</style>
